"use strict";

exports.__esModule = true;
exports.devicePredicate = void 0;
var devicePredicate = exports.devicePredicate = function devicePredicate(query, item) {
  var nameMatches = item.name.toLowerCase().includes(query.toLowerCase());
  var uuidMatches = item.uuid.toLowerCase().includes(query.toLowerCase());
  var tagMatches = item.tags.find(function (tag) {
    return tag.toLowerCase().includes(query.toLowerCase());
  }) !== undefined;
  return nameMatches || tagMatches || uuidMatches;
};